import InputBirthday from "@/components/Input/InputBirthday";
import { memo, useCallback } from "react";
import type { FieldRenderInputProps } from "../../types";
import { BaseField } from "./BaseField";
import type { BaseFieldProps } from "./BaseField";

/**
 * 日付入力フィールドコンポーネント
 * 日付の入力に特化したフィールド
 */
export const DateField = memo(
  ({
    fieldId,
    field,
    layout,
    readOnly,
    disabled,
    className,
    "data-testid": testId,
  }: BaseFieldProps) => {
    // 入力レンダリング関数
    const renderInput = useCallback((props: FieldRenderInputProps) => {
      // 日付形式に変換
      let dateValue = "";
      if (props.value) {
        if (props.value instanceof Date) {
          dateValue = props.value.toISOString().split("T")[0];
        } else if (typeof props.value === "string") {
          dateValue = props.value;
        }
      }

      // 入力変更ハンドラー
      const handleDateChange = (newValue: string) => {
        props.onChange(newValue);
      };

      return (
        <div>
          <InputBirthday
            value={dateValue}
            onChange={handleDateChange}
            className={`w-full ${props.error ? "border-red-500" : ""}`}
          />
        </div>
      );
    }, []);

    // BaseFieldを使用して日付フィールドをレンダリング
    return (
      <BaseField
        fieldId={fieldId}
        field={field}
        layout={layout}
        readOnly={readOnly}
        disabled={disabled}
        className={className}
        data-testid={testId}
        renderInput={renderInput}
      />
    );
  },
);

DateField.displayName = "DateField";
